
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Authentication } from '@/components/Authentication';
import { UsersRepository } from '@/repository/UsersRepository';
import SignUpConfirmation from '@/components/SignUpConfirmation.vue';

@Component({
  components: {
    SignUpConfirmation,
  },
})
export default class SignUp extends Vue {
  // private name: string = '';
  // name: default email
  private email: string = '';
  private password: string = '';
  private isConfirmingSignUp: boolean = false;

  private async signup() {
    const signupCompleted = await Authentication.signUp(this.email, this.password)
      .catch((err) => this.failedSigningUp(err));
    this.openConfirmingWindow();
  }

  private async onConfirmationFinished() {
    this.closeConfirmingWindow();
    await Authentication.signIn(this.email, this.password);
    UsersRepository.create(this.email).catch((err) => this.failedSigningUp(err));
    this.$router.push('/');
  }

  private onConfirmationCanceled() {
    this.closeConfirmingWindow();
    alert('確認処理が中断されました。確認処理を再開するには、ログイン画面で登録時のメールアドレス/パスワードを入力してください。');
    this.$router.push('/signin');
  }

  private failedSigningUp(err: any) {
    // alert('サインアップに失敗しました');
  }

  private openConfirmingWindow() {
    this.isConfirmingSignUp = true;
  }

  private closeConfirmingWindow() {
    this.isConfirmingSignUp = false;
  }
}
